$(document).on('click', '.bn_help-centre-feedback', function () {
    let that = $(this),
        type = that.data('type'),
        id = that.data('id'),
        container = that.parents('.bn_help-centre__articles-feedback'),
        input = container.find('.bn_help-centre__articles-feedback-form-textarea'),
        form = container.find('.bn_help-centre__articles-feedback-form-wrapper'),
        error = container.find('.bn_help-centre__articles-feedback-form-input');

    if  (type === 'like') {
        $.post('/help-centre/help-centre/like', {'id': id}, function() {
            if (form.is(':visible')) {
                form.stop().slideUp(400, function () {
                    container.addClass('active');
                });
            } else {
                container.addClass('active');
            }

            error.removeClass('error');

            setTimeout(function () {
                input.val('');

                container.removeClass('active');
            }, 4000)
        });
    } else {
        if (form.is(':hidden')) {
            $.post('/help-centre/help-centre/dislike', {'id': id}, function() {
                form.stop().slideDown();
            });
        }
    }
});

$(document).on('submit', '.bn_help-centre__articles-feedback-form', function(event) {
    event.preventDefault();

    let that = $(this),
        id = that.data('id'),
        container = that.parents('.bn_help-centre__articles-feedback'),
        form = container.find('.bn_help-centre__articles-feedback-form-wrapper'),
        error = container.find('.bn_help-centre__articles-feedback-form-input'),
        input = container.find('.bn_help-centre__articles-feedback-form-textarea'),
        message = input.val();

    if (message) {
        error.removeClass('error');

        $.post('/help-centre/help-centre/report', {'id': id, 'message': message}, function() {
            form.stop().slideUp(400, function () {
                input.val('');

                container.addClass('active');

                setTimeout(function () {
                    container.removeClass('active');
                }, 4000)
            });
        });
    } else {
        error.addClass('error');
    }
});

$(document).on('click', '.bn_help-centre__articles-sidebar-category-title', function () {
    let that = $(this),
        container = that.parents('.bn_help-centre__articles-sidebar-category'),
        list = container.find('.bn_help-centre__articles-sidebar-category-list');

    container.toggleClass('open');

    list.stop().slideToggle();
});

$(document).on('click', '.bn_help-centre__articles-faq-item-heading', function () {
    let that = $(this),
        container = that.parents('.bn_help-centre__articles-faq-item'),
        content = container.find('.bn_help-centre__articles-faq-item-content');

    if (container.hasClass('active')) {
        $('.bn_help-centre__articles-faq-item-content').stop().slideUp();

        $('.bn_help-centre__articles-faq-item').removeClass('active');
    } else  {
        $('.bn_help-centre__articles-faq-item-content').stop().slideUp();

        $('.bn_help-centre__articles-faq-item').removeClass('active');

        container.addClass('active');

        content.stop().slideDown();
    }
});

var timer;
$(document).on('input', '.bn_help-centre__heading-search-input', function() {
    let that = $(this),
        value = $.trim($(this).val()),
        container = that.parents('.bn_help-centre__heading-search-input-container');

    container.removeClass('error');

    clearTimeout(timer);

    if (value.length < 3) {
        container.removeClass('active');

        timer = setTimeout(function () {
            container.addClass('error');
        }, 1500)
    } else {
        container.addClass('active');

        container.removeClass('error');
    }
});

$(document).on('submit', '.bn_help-centre__heading-search-form', function(event) {
    let that = $(this),
        container = that.find('.bn_help-centre__heading-search-input-container'),
        input = that.find('.bn_help-centre__heading-search-input'),
        value = input.val();

    if (value.length < 3) {
        event.preventDefault();

        container.addClass('error');
    }
});